<template>
    <div>
        <transition name="modal">
            <div class="modal" style="display: block">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">


                            <h5 class="modal-title abtg__modal-title" id="exampleModalLabel">
                                TI PIACE QUESTO TOOL?</h5>

                            <div class="tools">
                                <div class="abtg__close-button"><a data-dismiss="modal" @click="closeModal()"><i
                                        class="fas fa-times"></i></a></div>

                            </div>

                        </div>
                        <form @submit.prevent="onSubmit">
                            <div class="modal-body">
                                <h3 class="text-center" v-html="content.questionRate"></h3>
                                <hr>
                                <p class="text-center abtg__rating-star">
                                <span v-for="(cnt, index) in newCounter"
                                      @mouseover="mouseOver(index)"
                                      @mouseleave="mouseLeave(index)"
                                >
                                    <i :class="cnt"></i>

                                </span>
                                </p>


                                <div class="form-group" style="margin-top:30px;">
                                    <textarea class="form-control" rows="3"
                                              v-model="comment"
                                              placeholder="Lascia un commento (opzionale)"></textarea>
                                </div>
                            </div>
                            <div class="modal-footer">

                                <button type="submit" class="btn btn-success abtg__btn-default abtg__btn-star "

                                        data-dismiss="modal">Invia Feedback
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>


    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'rating/getField',
        mutationType: 'rating/updateField',
    });

    export default {
        props: ['content'],
        components: {},
        data: function () {
            return {
                // newCounter: [],
                newCounter: {
                    1: 'far fa-star',
                    2: 'far fa-star',
                    3: 'far fa-star',
                    4: 'far fa-star',
                    5: 'far fa-star',
                }
            }
        },

        computed: {
            ...mapFields(['comment', 'star', 'section']),
        },
        created: function () {
            // this.init();
        },
        methods: {
            init: function () {
                for (let i = 1; i < 6; i++) {
                    this.newCounter[i] = 'far fa-star';
                }
            },
            mouseOver: function (index) {
                this.init();
                for (let i = 1; i < 6; i++) {
                    if (i <= index) {
                        this.newCounter[i] = 'fas fa-star';
                    }
                }
            },
            mouseLeave: function (index) {
                this.star = index;
            },
            closeModal: function () {
                this.$store.dispatch(this.content.storeModule + '/openCloseRatingModal' , {section: this.content.section});
            },

            onSubmit: function()
            {
                this.section = this.content.section;
                this.$store.dispatch('rating/saveRating');
                this.closeModal();
            }


        }
    }
</script>